__turbopack_context__.v({
  "Input": "index-module__CYiI-G__Input",
  "Item": "index-module__CYiI-G__Item",
  "Label": "index-module__CYiI-G__Label",
  "MovieItem": "index-module__CYiI-G__MovieItem",
  "MovieName": "index-module__CYiI-G__MovieName",
  "MovieYear": "index-module__CYiI-G__MovieYear",
  "Popup": "index-module__CYiI-G__Popup",
  "Positioner": "index-module__CYiI-G__Positioner",
  "Spinner": "index-module__CYiI-G__Spinner",
  "Status": "index-module__CYiI-G__Status",
  "Viewport": "index-module__CYiI-G__Viewport",
  "autocompleteSpinner": "index-module__CYiI-G__autocompleteSpinner",
});
